import { Box, Caption } from 'components';

const PokemonIdleView = () => {
  return (
    <Box>
      <Caption text="Please, enter pokemon name." />
    </Box>
  );
};

export default PokemonIdleView;
